import { Component, EventEmitter, Input, Output, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ISummaryData } from '../../../../../core/models/summary-data';
import { ModalExtraRefillComponent } from './components/modal-extra-refill/modal-extra-refill.component';
import { ModalExtraWashingComponent } from './components/modal-extra-washing/modal-extra-washing.component';
import { ComponentType } from '@angular/cdk/portal';
import { MappedTopping } from '../../../../../core/interfaces/funnel.interface';
import { SummaryService } from '../../../../../core/services/summary.service';
import { FunnelService } from '../funnel.service';
import { finalize } from 'rxjs';
import { LoaderService } from '../../../../../core/services/loader.service';

@Component({
  selector: 'app-extras',
  standalone: false,
  templateUrl: './extras.component.html',
  styleUrl: './extras.component.scss',
})
export class ExtrasComponent {
  @Input() mappedToppings: MappedTopping[] = [];
  @Output() nextStep = new EventEmitter<void>();
  topping: any = null;
  summaryData: ISummaryData = {} as ISummaryData;
  selectedTopping: MappedTopping | null = null;
  selectedExtras: { [key: string]: any } = {};
  result: any = null;
  selectedToppingId: string | null = null;
  orderHash: string | null = null;
  selectedProduct: {
    id: string;
    name: string;
    price: number;
    description?: string;
    fuel?: string;
    amount?: number;
    productId: string;
  } | null = null;
  

  constructor(
    private viewContainerRef: ViewContainerRef,
    private dialog: MatDialog,
    summaryService: SummaryService,
    private funnelService: FunnelService,
    private loaderService: LoaderService
  ) {
    this.summaryData = summaryService.getSummary() || ({} as ISummaryData);
  }

  ngOnInit() {
    this.orderHash = this.summaryData.bookingResponse?.OrderHash || null;
    this.loadSavedData();
  }

  private loadSavedData(): void {
    this.summaryData = JSON.parse(localStorage.getItem('summaryData') || '{}');
    this.mappedToppings = JSON.parse(
      localStorage.getItem('mappedToppings') || '[]'
    );
    console.log('Mapped Toppings:', this.mappedToppings);
  }

  getMinimumPrice(products: any[]): number {
    if (!products?.length) return 0;
    return Math.min(...products.map((p) => p.price));
  }

  onModalClose() {
    this.selectedTopping = null;
  }

  onModalSave(data: any) {
    this.selectedExtras[data.toppingId] = data.productId ?? data.formData;
    this.selectedTopping = null;
  }

  handleTopping(topping: MappedTopping): void {
    if (topping.hasModal) {
      this.selectedTopping = topping;
    } else {
      // Si no hay modal, puedes manejar la selección directa aquí si aplica
    }
  }

  openModal(id: string): void {
    this.selectedToppingId = id;
    console.log('Selected Topping ID:', this.selectedToppingId);
    const orderHash = this.summaryData.bookingResponse?.OrderHash;
    const data = {
      orderHash: orderHash,
      mappedTopping: this.mappedToppings.find((t) => t.id === id),
    };
    const modalConfig: MatDialogConfig = {
      data,
      width: '334px',
      height: '530px',
      viewContainerRef: this.viewContainerRef,
      disableClose: false,
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
    };

    const modalComponentMap: { [key: string]: ComponentType<any> } = {
      refueling: ModalExtraRefillComponent,
      wash: ModalExtraWashingComponent,
    };

    const dialogRef = this.dialog.open(modalComponentMap[id], modalConfig);

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Modal closed with result:', result);
      if (result.incompletedTopping) return;

      const id = this.selectedToppingId ?? 'unknown';
    
      const isRefueling = id === 'refueling';
    
      // // Si ya hay uno seleccionado, eliminarlo
      // if (this.selectedProduct?.productId && this.orderHash) {
      //   this.funnelService.removeTopping(this.orderHash, this.selectedProduct.productId).subscribe();
      // }
    
      this.selectedProduct = {
        id,
        name: isRefueling ? 'Repostaje' : (result.selectedProduct?.titleId || 'Servicio'),
        price: Number(result.selectedProduct?.price ?? 0),
        description: result.selectedProduct?.descriptionId || '',
        fuel: isRefueling ? result.selectedFuel : undefined,
        amount: isRefueling ? Number(result.selectedAmount ?? 0) : undefined,
        productId: result.selectedProduct?.id
      };
    });
  }

  next() {
    this.nextStep.emit(this.result);
  }

  
  removeSelectedProduct(event: Event): void {
    event.stopPropagation();
  
    if (this.orderHash && this.selectedProduct?.productId) {
      this.loaderService.show();
      this.funnelService.removeTopping(this.orderHash, this.selectedProduct.productId).pipe(
              finalize(() => this.loaderService.hide()),
            ).subscribe();
    }
  
    this.selectedProduct = null;
  }
  
}
